import React from "react";
import {
  formatAiUsageAud,
  formatAiUsageCount,
  formatChangePct,
  getChangePctTone,
} from "./aiUsageOverview.utils";

const KpiCard = ({ label, value, hint, hintClassName = "text-gray-500" }) => (
  <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
    <p className="mt-1 text-2xl font-semibold text-gray-900">{value}</p>
    {hint ? <p className={`mt-1 text-xs ${hintClassName}`}>{hint}</p> : null}
  </div>
);

const AiUsageKpiStrip = ({ totals = {}, comparison = {} }) => {
  const changeLabel = comparison?.prior_from && comparison?.prior_to
    ? `vs ${comparison.prior_from} → ${comparison.prior_to}`
    : "vs prior period";

  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        label="AI spend (AUD)"
        value={formatAiUsageAud(totals.spent_aud)}
        hint={`${formatChangePct(comparison.change_pct)} ${changeLabel}`}
        hintClassName={getChangePctTone(comparison.change_pct)}
      />
      <KpiCard
        label="AI calls"
        value={formatAiUsageCount(totals.call_count)}
        hint={`${formatAiUsageCount(totals.input_tokens)} in / ${formatAiUsageCount(totals.output_tokens)} out tokens`}
      />
      <KpiCard
        label="Active tenants"
        value={formatAiUsageCount(totals.active_tenant_count)}
        hint={`${formatAiUsageCount(totals.tenant_count_with_balance)} with wallet balance`}
      />
      <KpiCard
        label="USD equivalent"
        value={formatAiUsageAud(totals.spent_usd)}
        hint="Provider-side USD estimate for the selected range"
      />
    </div>
  );
};

export default AiUsageKpiStrip;
